import { render, staticRenderFns } from "./LoginAccountPassword.vue?vue&type=template&id=5c35f683&scoped=true&"
import script from "./LoginAccountPassword.vue?vue&type=script&lang=js&"
export * from "./LoginAccountPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginAccountPassword.vue?vue&type=style&index=0&id=5c35f683&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35f683",
  null
  
)

export default component.exports